export const AuctionSettingsTipsTranslation = {
    en: `
Automatic mode will only work if the browser tab is open.
    `,
    uk: `
Автоматичний режим працює лише за умови, що вкладка браузера відкрита.
    `
}
